<app-factor-table
  [title]="'Consumption'" [factors]="factorsData"
  [formatters]="formatters" [modalFilterHeaders]="modalFilterHeaders">
</app-factor-table>